import React from 'react';
import Home from './pages/home';

const AppContent: React.FC = () => <Home />;

export default AppContent;
